import * as React from 'react';

export interface IPhoneButtonProps {
  button: React.ReactNode;
  content: React.ReactNode;
  phoneVisible: boolean;
  onShow(): void;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ button, content, phoneVisible, onShow }) => {
  return phoneVisible ? (
    <div>{content}</div>
  ) : (
    <div data-name="PhoneButton" onClick={onShow}>
      {button}
    </div>
  );
};
